import { apiClient } from "@/lib/api/http"

export interface CountryCurrency {
  id: number
  country: string
  currency: string
  code: string
  number: string
  currencyExponent: string
  isDefault: boolean
  createdAt: string
  updatedAt: string
}

interface Envelope<T> {
  success: boolean
  statusCode: number
  message: string
  data: T
}

export async function getCountryCurrencies(token?: string | null): Promise<CountryCurrency[]> {
  const headers: Record<string, string> = {}
  if (token) headers["Authorization"] = `Bearer ${token}`

  const { data: envelope } = await apiClient.get<Envelope<CountryCurrency[]>>(
    "/tax/country-currencies",
    { headers }
  )
  return envelope.data
}
